

export function validate(dom) {
  return new Promise((resolve,reject) => {
    dom.validate(valid => {
      if(valid) {
        resolve()
      }else {
        reject()
        return false
      }
    })
  })
}

export function required(trigger) {
  let message = '该项为必填项'
  !trigger && (trigger = 'blur')
  return { required:true, message,trigger }
}

export function noEmpty(trigger) {
  const validator = function (rule,value,callback) {
    if(value.indexOf(' ') !== -1) {
      callback(new Error(`不能存在空格`))
    }else {
      callback()
    }
  }
  !trigger && (trigger = 'blur')
  return {validator,trigger}
}

export function mustNumber(trigger) {
  const message = '必须为数字'
  const validator = function (rule,value,callback) {
    if(Object.is(Number(value),NaN)) {
      callback(new Error(message))
    }else {
      callback()
    }
  }
  !trigger && (trigger = 'blur')
  return {validator,trigger}
}

export function phoneLen(trigger) {
  const message = '必须为11位手机号码'
  const validator = function (rule,value,callback) {
    if(value.length !== 11) {
      callback(new Error(message))
    }else {
      callback()
    }
  }
  !trigger && (trigger = 'blur')
  return {validator,trigger}
}

//检查合同期限格式
export function contractTime(trigger){
  const validator = function (rule,value,callback) {
    if(value < 0){
      callback(new Error('请输入大于0的数值'))
    }else if(value >= 10){
      callback(new Error('请输入小于10的数值'))
    }else{
      callback()
    }
  }
  !trigger && (trigger = 'blur')
  return {validator,trigger}
}

//验证密码
export function pwdFormat(trigger) {
  const message = '密码由8-16位,数字、大写字母、小写字母、特殊字符三种及以上组合。'
  const validator = function (rule,value,callback) {
    let reg = /^(?![a-zA-Z]+$)(?![a-zA-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/
    if(!reg.test(value)) {
      callback(new Error(message))
    }else{
      callback()
    }
  }
  !trigger && (trigger = 'blur')
  return {validator,trigger}
}

export function phoneFormat(trigger) {
  const validator = (rule, value, callback) => {
    if(value.length  !== 11 ) return callback(new Error('必须为11位手机号码'))
    // let str = new RegExp("^1[35789]\\d{9}$");
    let str = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/
    if(!str.test(value)){
      callback(new Error('手机号错误！'))
    }else{
      callback()
    }
  }
  !trigger && (trigger = 'blur')
  return {validator,trigger}
}


export function mustPositive(trigger) {
  const message = '必须为正数'
  const validator = function (rule,value,callback) {
    if(value && !Object.is(Number(value),NaN) && Number(value) <= 0) {
      callback(new Error(message))
    }else {
      callback()
    }
  }
  !trigger && (trigger = 'blur')
  return {validator,trigger}
}


// WEBPACK FOOTER //
// ./src/util/rules.js